/// <amd-module name="typeahead/features/ClientSideCacheDisabler" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IClientSideCacheStatusChecker} from "typeahead/dataprovider/IClientSideCacheStatusChecker";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 24928,
            name: "UtaTurnOffClientSideCache",
            value: 1,
        },
    },
];

export class ClientSideCacheDisabler implements IExperimentalFeature, IClientSideCacheStatusChecker {
    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public isClientSideCacheDisabled(context: IContext): boolean {
        return ExecutionHelper.shouldExecute(context, configuration);
    }
}
